module.exports = __webpack_public_path__ + "img/dne-token-coin.08d609bc.png";